// Poster/play-button overlay for videos that play inline in their container.
// Distinct from `.video-active`, which opens the shared `.video-overlay` modal.
(function($) {
    $(document).ready(function() {
        $(document).on('click', '.inline-video .inline-video-play', function(e) {
            e.preventDefault();
            var $container = $(this).closest('.inline-video');
            var video = $container.find('video').get(0);
            if (!video) {
                return;
            }
            $container.addClass('playing');
            video.muted = false;
            var playing = video.play();
            // Safari/iOS reject an unmuted play() if the gesture isn't trusted.
            if (playing && typeof playing.catch === 'function') {
                playing.catch(function() {
                    video.muted = true;
                    video.play();
                });
            }
        });

        $('.inline-video video').on('ended', function() {
            var $container = $(this).closest('.inline-video');
            this.currentTime = 0;
            $container.removeClass('playing');
        });
    });
})(jQuery);
